import { TextField } from '@material-ui/core';
import { format } from 'date-fns';
import React, { useCallback, useRef } from 'react';
import InputMask from 'react-input-mask';

interface Enderecos {
  bairro_endereco?: string;
  cependereco?: string;
  cidade_endereco?: string;
  codigo_ibgelogradouro?: string;
  complemento_endereco?: string;
  dddtelefone?: string;
  endereco?: string;
  finalidade_endereco?: string;
  numero_endereco?: string;
  numero_telefone_com_ddd?: string;
  ponto_referencia_end?: string;
  tipo_endereco?: string;
  ufendereco?: string;
}

interface PrincipalEmailCliente {
  email?: string;
  tipo?: string;
}

interface TelefoneCliente {
  Residencial?: string;
}

interface Contatos {
  email_Contato_Cliente?: string;
}

interface DadosPessoais {
  CPF_CNPJ_CLENTE?: string;
  Codigo_Cliente_Siebel?: string;
  Data_Nascimento_Cliente?: string;
  Enderecos: Enderecos[];
  Nome_cliente?: string;
  Principal_Email_Cliente: PrincipalEmailCliente[];
  Sobrenome_cliente?: string;
  Telefone_Cliente: TelefoneCliente[];
  numero_proposta?: string;
  contatos: Contatos[];
}

interface ParquesClientes {
  Categoria_Produto_Cliente?: string;
  Nome_Produto_Cliente?: string;
}

interface Produtos {
  parques_clientes: ParquesClientes[];
}

interface DadosPessoais {
  dadosPessoais: DadosPessoais;
}

interface Propostas {
  Numero_Proposta_Prosponente?: string;
  Nome_Proponente?: string;
  Nome_Meio_Poroponente?: string;
  Sobrenome_Proponente?: string;
  Endereço_Instalacao_Proponente?: string;
  Numero_End_Instalacao_Proponente?: string;
  Complemento_Instalacao_Proponente?: string;
  Bairro_Proponente?: string;
  CEP_Instalacao_Proponente?: string;
  Cidade_Instalacao_Proponente?: string;
  Estado_Instalacao_Proponente?: string;
  Telefone_Proponente?: string;
  Tipo_Residencia_Instalacao_Proponente?: string;
  Telefone_Residencial_Proposta_Prosponente?: string;
  Email_Pessoal_Proponente?: string;
  Email_Comercial_Proponente?: string;
  Celular_Proponente?: string;
  Celular_pessoal_Proponente?: string;
  Telefone_Comercial_Proponente?: string;
  CPF_Proponente?: string;
  RG_Proponente?: string;
}

interface Instaladores {
  Numero_instalador?: string;
  Nome_Instalador?: string;
  Email_Instalador?: string;
  RG_Instalador?: string;
  CPF_Instalador?: string;
  Celular_com_DDD_Instalador?: string;
  Telefone_1_com_DDD_Instalador?: string;
  Telefone_2_com_DDD_Instalador?: string;
  Telefone_3_com_DDD_Instalador?: string;
  Telefone_4_com_DDD_Instalador?: string;
  Endereco_Instalador?: string;
  Complemento_Endereco_Instalador?: string;
  Cidade_Logradouro_Instalador?: string;
  CEP_Logradouro_Instalador?: string;
  Numero_Endereco_Instalador?: string;
  Telefone_Contato_referencia_Instalador?: string;
}

interface PontosDeVenda {
  conta?: string;
  CPF_Parceiro_Vendedor?: string;
  RG_Parceiro_Vendedor?: string;
  Nome_Empresa_Vendedor?: string;
  Nome_Parceiro_Vendedor?: string;
  Sobrenome_Parceiro_Vendedor?: string;
  Email_Parceiro_Vendedor?: string;
  Telefone_Res_Parceiro_Vendedor?: string;
  Celular_Parceiro_Vendedor?: string;
  Outro_Telefone_Parceiro_Vendedor?: string;
  Foto_Parceiro_Vendedor?: string;
  Genero_Vendedor?: string;
  Telefone_Parceiro_Vendedor?: string;
}

interface Proposta {
  Numero_Proposta?: string;
  Nome_Prosponente?: string;
  Sobrenome_Prosponente?: string;
  endereco?: string;
  numero_endereco?: string;
  complemento_endereco?: string;
  cependereco?: string;
  cidade_endereco?: string;
  ufendereco?: string;
  Email_Prosponente?: string;
  Telefone_Celular_Proponente?: string;
  Telefone_Comercial_Prosponente?: string;
  Telefone_Residencial_Prosponente?: string;
  CPF_Prosponente?: string;
  RG_Prosponente?: string;
  Passaporte_Prosponente?: string;
  bairro_endereco?: string;
  apartamento?: string;
}

interface Terceiros {
  conta?: string;
  CPF_Terceiro?: string;
  RG_Terceiro?: string;
  Nome_Terceiro?: string;
  Email_Terceiro?: string;
  Email_Gestor_Terceiro?: string;
  Numero_Fax_Terceiro?: string;
  Numero_Telefone_Reidencia_Terceiro?: string;
  Numero_Celular_Terceiro?: string;
  Numero_Telefone_Terceiro?: string;
  Caixa_Postal_Terceiro?: string;
  Endereco_Terceiro?: string;
  UF_Terceiro?: string;
  proposta?: Proposta[];
  Login_EPS_Terceiro?: string;
  EPS_Callcenter_Terceiro?: string;
  EPS_Celula_Callcenter_Terceiro?: string;
  Login_Avaya_Terceiro?: string;
  Matricula_EPS_Terceiro?: string;
  Numero_logradouro_Terceiro?: string;
  Complemento_Endereco_Terceiro?: string;
  Cidade_logradouro_Terceiro?: string;
  Distrito_Logradouro_Terceiro?: string;
  Data_Nascimento_Terceiro?: string;
}

export interface Dados_Cadastrais {
  Matricula_Empregado?: string;
  Nome_Empregado?: string;
  CPF_Empregado?: string;
  Genero_Empregado?: string;
  Data_Nascimento_Empregado?: string;
  Endereco_Residencial_Empregado?: string;
  Numero_Logradouro_Empregado?: string;
  Complemento_Endereco_Empregado?: string;
  Cidade_Endereco_Empregado?: string;
  CEP_Endereco_Empregado?: string;
  Tipo_Endereco_Empregado?: string;
  Estado_Endereco_Empregado?: string;
  Telefone_Residencial_Empregado?: string;
  Celular_Empregado?: string;
  Email_Pessoal_Empregado?: string;
  UF_Emissor_RG_Empregado?: string;
  Dt_Expedicao_Emissor_RG_Empregado?: string;
  Estado_CTPS_Empregado?: string;
  Data_Expedicao_CTPS_Empregado?: string;
  Dt_Validade_CTPS_Empregado?: string;
  Numero_PIS_Empregado?: string;
  DT_Expedicao_PIS_Empregado?: string;
  Numero_Beneficio_INSS_Empregado?: string;
  RG_Empregado?: string;
  Orgao_Emissor_RG_Empregado?: string;
  Letra_CTPS_Empregado?: string;
  Numero_CTPS_Empregado?: string;
  Serie_CTPS_Empregado?: string;
  Numero_Inscricao_INSS_Empregado?: string;
  Classe_Contribuicao_INSS_Empregado?: string;
  Numero_RIC_Empregado?: string;
  Orgao_Emissor_RIC_Empregado?: string;
  Data_Expedicao_RIC_Empregado?: string;
  Carteira_Habilitacao_Empregado?: string;
  Categoria_CNH_Empregado?: string;
  Orgao_Emissor_CNH_Empregado?: string;
  Data_Expedicao_CNH_Empregado?: string;
  Data_Validade_CNH_Empregado?: string;
  UF_Expedicao_CNH_Empregado?: string;
  Dt_Primeira_Hab_CNH_Empregado?: string;
  Carteira_Habilitacao_2019?: string;
  Orgao_Carteira_Habilitacao_2019?: string;
  Data_expedicao_Carteira_Hab_2019?: string;
  Numero_Titulo_Eleitor_Empregado?: string;
  Secao_TE_Empregado?: string;
  Zona_TE_Empregado?: string;
  Certificado_Reservista_Empregado?: string;
  Complemento_CR_Empregado?: string;
  Codgio_Orgao_Classe_Empregado?: string;
  Regiao_Orgao_Classe_Empregado?: string;
  Numero_Regiao_Orgao_Classe_Empregado?: string;
  UF_Orgao_Classe_Empregado?: string;
  Dt_Expedicao_Orgao_Classe_Empregado?: string;
  Dt_Validade_Orgao_Classe_Empregado?: string;
  Data_Admissao_Empregado?: string;
  Data_Termino_Contrato_Empregado?: string;
  Nome_Mae_Empregado?: string;
  Nome_Pai_Empregado?: string;
  Natureza_Estagio?: string;
  CPF_Coordenador_Estagio?: string;
  Nome_Coordenador_Estagio?: string;
  Apolice_Seguro_Estagio?: string;
  Data_Fim_Estagio?: string;
}

export interface Dados_Financeiros {
  Codigo_Banco_Empregado?: string;
  Codigo_Agencia_Bancaria_Empregado?: string;
  Conta_Corrente_Empregado?: string;
  DV_Conta_Corrente_Empregado?: string;
}

export interface Dependentes {
  Nome_Dependente?: string;
  Data_Nascimento_Dependente?: string;
  Numero_CPF_Dependente?: string;
  Numero_RG_Dependente?: string;
  Estado_Emissor_RG_Dependente?: string;
  Orgao_Emissor_RG_Dpendente?: string;
  Data_Expedicao_RG_Dependente?: string;
  Ds_Parentesco?: string;
  Cartorio_Registor_Dependente?: string;
  NRO_REGISTRO?: string;
  Numero_Livro_Registro_Dep?: string;
  Numero_Folha_Registro_Dep?: string;
  Genero_Dependente?: string;
}

export interface Beneficiarios {
  Nome_Beneficiario?: string;
  Numero_CPF_Beneficiario?: string;
  Numero_RG_Beneficiario?: string;
  Orgao_Emissor_RG_Beneficiario?: string;
  Estado_Emissor_RG_Beneficiario?: string;
  Endereco_Beneficiario?: string;
  Numero_Endereco_Beneficiario?: string;
  Complemento_End_Beneficiario?: string;
  Bairro_Beneficiario?: string;
  Cidade_Beneficiario?: string;
  Estado_Beneficiario?: string;
  CEP_Beneficiario?: string;
}

export interface DadosCadastraisFuncionario {
  tem_dependentes?: string;
  tem_beneficiarios?: string;
  Dados_Cadastrais?: Dados_Cadastrais;
  Dados_Financeiros?: Dados_Financeiros;
  Dependentes?: Dependentes[];
  Beneficiarios?: Beneficiarios[];
}

interface DadosCadastraisCandidato {
  CPF_Candidato?: string;
  Nome_Candidato?: string;
  Sobrenome_Candidato?: string;
  Data_Nascimento_Candidato?: string;
  Numero_RG_Candidato?: string;
  Codigo_Postal_Candidato?: string;
  Endereco_residencial_Candidato?: string;
  Endereco_Linha_2_residencial_Candidato?: string;
  Complemento_Endereco_cancidato?: string;
  Cidade_Candidato?: string;
  Regiao_Logradouro_Candidato?: string;
  Estado_Candidato?: string;
  Pais_Logradouro_Candidato?: string;
  Email_Candidato?: string;
  Tipo_Telefone_Contato_Principal?: string;
  Celular_Candidato?: string;
  Telefone_Comercial_Candidato?: string;
  Numero_PIS_Candidato?: string;
  Data_Emissao_PIS_Candidato?: string;
  Numero_NIT?: string;
  Data_Cadastro_NIT?: string;
}
interface Assinante {
  dadosPessoais?: DadosPessoais;
  Produtos?: Produtos;
}
export interface PersonalCategoriasData {
  tem_dependentes?: boolean;
  tem_beneficiarios?: boolean;
  tipo?: number;
  Produtos?: Produtos;
  dadosPessoais?: DadosPessoais;
  propostas?: Propostas[];
  proposta?: Proposta[];
  instaladores?: Instaladores[];
  pontos_de_venda?: PontosDeVenda[];
  terceiros?: Terceiros[];
  dados_cadastrais_funcionario: DadosCadastraisFuncionario;
  dados_cadastrais_candidato: DadosCadastraisCandidato[];
}

interface PersonalData {
  selectCount: any;
  personal: PersonalCategoriasData;
  tipo?: number;
  assinante: Assinante[];
  dados_cadastrais_funcionario: DadosCadastraisFuncionario[];
  instaladores?: Instaladores[];
  pontos_de_venda?: PontosDeVenda[];
  terceiros?: Terceiros[];
  propostas: Propostas[];
  proposta: Proposta[];
  dados_cadastrais_candidato: DadosCadastraisCandidato[];
}

interface CategoriasProps {
  personalData?: PersonalData;
}

const Categorias: React.FC<CategoriasProps> = ({ personalData }) => {
  const RInputMask = useRef<InputMask>(null);

  const renderInfo = useCallback(() => {
    //@ts-ignore
    const { consentimento, anonym_request } = personalData;

    const status: string[] = [];

    for (let i = 0; i < consentimento.length; i++) {
      const element = consentimento[i];
      status.push(element.personal_response);
    }

    return (
      <>
        <h2
          className="cancel-text"
          style={{
            borderTop: '1px #707070 solid',
            paddingTop: 27,
            fontSize: '2rem',
          }}
        >
          Atividades com base legal de Consentimento
        </h2>

        <h2
          className="cancel-text"
          style={{
            fontSize: '1.6rem',
            marginBottom: 15,
          }}
        >
          Atividades autorizadas pelo titular
        </h2>
        <ul style={{ paddingLeft: 20 }}>
          {consentimento[0] &&
            consentimento.map((el: any, index: any) => {
              return (
                <div key={`Atividades-com-consentimento${index + 1}`}>
                  {el.personal_response === 'S' ? (
                    <li
                      className="cancel-text"
                      style={{
                        fontSize: '1.4rem',
                        color: '#c7c7c7',
                      }}
                    >
                      {el.operation_describe}
                    </li>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}

          {!status.includes('S') ? (
            <li
              className="cancel-text"
              style={{
                fontSize: '1.4rem',
                color: '#c7c7c7',
                listStyle: 'none',
              }}
            >
              Não há atividades autorizadas
            </li>
          ) : (
            ''
          )}
        </ul>

        <h2
          className="cancel-text"
          style={{
            fontSize: '1.6rem',
            marginBottom: 15,
          }}
        >
          Atividades não autorizadas pelo titular
        </h2>

        <ul style={{ paddingLeft: 20 }}>
          {consentimento[0] &&
            consentimento.map((el: any, index: any) => {
              return (
                <div key={`Atividades-sem-consentimento${index + 1}`}>
                  {el.personal_response === 'N' ? (
                    <li
                      className="cancel-text"
                      style={{
                        fontSize: '1.4rem',
                        color: '#c7c7c7',
                      }}
                    >
                      {el.operation_describe}
                    </li>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}

          {!status.includes('N') ? (
            <li
              className="cancel-text"
              style={{
                fontSize: '1.4rem',
                color: '#c7c7c7',
                listStyle: 'none',
              }}
            >
              Não há atividades não autorizadas
            </li>
          ) : (
            ''
          )}
        </ul>

        {!!anonym_request?.request_anonym_dt ? (
          <>
            <h2
              className="cancel-text"
              style={{
                borderTop: '1px #707070 solid',
                paddingTop: 27,
                fontSize: '2rem',
              }}
            >
              Solicitação de Exclusão
            </h2>
            <h2
              className="cancel-text"
              style={{
                fontSize: '1.6rem',
              }}
            >
              Solicitação de exclusão efetuada no dia{' '}
              {format(new Date(anonym_request.request_anonym_dt), 'dd/MM/yyyy')}
            </h2>
          </>
        ) : (
          <>
            <h2
              className="cancel-text"
              style={{
                borderTop: '1px #707070 solid',
                paddingTop: 27,
                fontSize: '2rem',
              }}
            >
              Solicitação de Exclusão
            </h2>
            <h2
              className="cancel-text"
              style={{
                fontSize: '1.6rem',
              }}
            >
              Não há solicitação de exclusão
            </h2>
          </>
        )}
      </>
    );
  }, [personalData]);

  const renderInfoTypeFour = useCallback(() => {
    const instaladores =
      personalData?.instaladores && personalData.instaladores[0];
    const terceiros = personalData?.terceiros && personalData.terceiros[0];
    const pontos_de_venda =
      personalData?.pontos_de_venda && personalData.pontos_de_venda[0];

    if (instaladores || terceiros || pontos_de_venda) {
      return (
        <div style={{ marginTop: -20 }}>
          <p style={{ color: '#FFF' }}>
            Para alguns casos, a Sky também possui informações sobre dados
            biométricos.
          </p>
        </div>
      );
    }
  }, [personalData]);

  return (
    <div className="content">
      {personalData?.tipo === 1 ? (
        <>
          {personalData?.assinante &&
            personalData.assinante[0] &&
            personalData.assinante.map((assinante, index) => {
              return (
                <div key={`key-assinante-${index + 1}`}>
                  <section>
                    <h2>
                      Contrato -{' '}
                      {assinante.dadosPessoais?.Codigo_Cliente_Siebel}
                    </h2>
                    <h3>Dados Cadastrais</h3>

                    {assinante.dadosPessoais?.Nome_cliente && (
                      <TextField
                        title={assinante.dadosPessoais.Nome_cliente}
                        disabled
                        label="Primeiro Nome"
                        value={assinante.dadosPessoais.Nome_cliente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {assinante.dadosPessoais?.Sobrenome_cliente && (
                      <TextField
                        title={assinante.dadosPessoais.Sobrenome_cliente}
                        disabled
                        label="Sobrenome"
                        value={assinante.dadosPessoais.Sobrenome_cliente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {assinante.dadosPessoais?.CPF_CNPJ_CLENTE && (
                      <InputMask
                        mask="999.999.999-99"
                        value={assinante.dadosPessoais.CPF_CNPJ_CLENTE}
                        name="CPF"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CPF"
                            disabled
                            title={assinante.dadosPessoais?.CPF_CNPJ_CLENTE}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {assinante.dadosPessoais?.Sobrenome_cliente && (
                      <TextField
                        title={assinante.dadosPessoais.Data_Nascimento_Cliente}
                        disabled
                        label="Data de nascimento"
                        value={assinante.dadosPessoais.Data_Nascimento_Cliente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {assinante?.dadosPessoais?.Principal_Email_Cliente &&
                      assinante?.dadosPessoais?.Principal_Email_Cliente[0] && (
                        <TextField
                          title={
                            assinante.dadosPessoais.Principal_Email_Cliente[0]
                              .email
                              ? assinante.dadosPessoais
                                  .Principal_Email_Cliente[0].email
                              : ''
                          }
                          disabled
                          label="Email Principal"
                          value={
                            assinante.dadosPessoais.Principal_Email_Cliente[0]
                              .email
                          }
                          variant="outlined"
                          className="TextField-lgpd-admin"
                        />
                      )}

                    {assinante.dadosPessoais?.Telefone_Cliente &&
                      assinante.dadosPessoais.Telefone_Cliente.map(
                        (telefone, index) => {
                          if (telefone) {
                            return (
                              <TextField
                                title={Object.values(telefone).toString()}
                                key={`Telefone_Cliente-${index + 1}`}
                                disabled
                                label={`Número ${Object.keys(telefone)}`}
                                value={Object.values(telefone)}
                                variant="outlined"
                                className="TextField-lgpd-admin"
                              />
                            );
                          }
                        },
                      )}

                    {assinante.dadosPessoais?.numero_proposta && (
                      <TextField
                        disabled
                        title={assinante.dadosPessoais.numero_proposta}
                        label="Número proposta"
                        value={assinante.dadosPessoais.numero_proposta}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {assinante.dadosPessoais?.Enderecos &&
                      assinante.dadosPessoais.Enderecos.map(
                        (Endereco, index) => {
                          if (Endereco) {
                            return (
                              <React.Fragment key={`Enderecos-${index + 1}`}>
                                {Endereco.cependereco && (
                                  <InputMask
                                    mask="99999-999"
                                    value={Endereco.cependereco}
                                    name="CPF"
                                    disabled
                                    maskChar=""
                                    ref={RInputMask}
                                    children={(inputProps: any) => (
                                      <TextField
                                        {...inputProps}
                                        label="CEP"
                                        disabled
                                        variant="outlined"
                                        className="TextField-lgpd-admin"
                                      />
                                    )}
                                  />
                                )}

                                {Endereco.tipo_endereco && (
                                  <TextField
                                    disabled
                                    label={Endereco.tipo_endereco}
                                    value={Endereco.endereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.numero_endereco && (
                                  <TextField
                                    disabled
                                    label="Número"
                                    value={Endereco.numero_endereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.complemento_endereco && (
                                  <TextField
                                    disabled
                                    label="Complemento"
                                    value={Endereco.complemento_endereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.bairro_endereco && (
                                  <TextField
                                    disabled
                                    label="Bairro"
                                    value={Endereco.bairro_endereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.cidade_endereco && (
                                  <TextField
                                    disabled
                                    label="Cidade"
                                    value={Endereco.cidade_endereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.ufendereco && (
                                  <TextField
                                    disabled
                                    label="UF"
                                    value={Endereco.ufendereco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {Endereco.numero_telefone_com_ddd && (
                                  <TextField
                                    disabled
                                    label="Número do contato para instalação"
                                    value={Endereco.numero_telefone_com_ddd}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}
                              </React.Fragment>
                            );
                          }
                        },
                      )}

                    {assinante.dadosPessoais?.contatos &&
                      assinante.dadosPessoais.contatos.map((contato, index) => {
                        if (contato.email_Contato_Cliente) {
                          return (
                            <TextField
                              key={`contato-${index + 1}`}
                              disabled
                              label="Endereço de e-mail de contato"
                              value={contato.email_Contato_Cliente}
                              variant="outlined"
                              className="TextField-lgpd-admin"
                            />
                          );
                        }
                      })}

                    <h3>Dados Produtos</h3>

                    {assinante.Produtos?.parques_clientes &&
                      assinante.Produtos.parques_clientes.map(
                        (produto, index) => {
                          if (produto) {
                            return (
                              <React.Fragment
                                key={`parques_clientes-${index + 1}`}
                              >
                                {produto.Nome_Produto_Cliente && (
                                  <TextField
                                    disabled
                                    label="Nome do Produto"
                                    value={produto.Nome_Produto_Cliente}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {produto.Categoria_Produto_Cliente && (
                                  <TextField
                                    disabled
                                    label="Categoria do Produto"
                                    value={produto.Categoria_Produto_Cliente}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}
                              </React.Fragment>
                            );
                          }
                        },
                      )}
                  </section>
                </div>
              );
            })}

          {!!personalData?.assinante[0] && (
            <div style={{ marginTop: -20 }}>
              {personalData?.assinante[0]?.Produtos?.parques_clientes[1]
                .Nome_Produto_Cliente === 'DIRECTV GO' ? (
                <p style={{ color: '#FFF' }}>
                  A DIRECTV GO também possui informações sobre perfil de
                  cobrança, faturamento e atendimento.
                </p>
              ) : (
                <p style={{ color: '#FFF' }}>
                  A SKY também possui informações sobre perfil de cobrança,
                  faturamento, ordens de serviço e atendimento.
                </p>
              )}
            </div>
          )}
        </>
      ) : (
        ''
      )}

      {personalData?.tipo === 2 ? (
        <>
          {personalData?.dados_cadastrais_funcionario &&
            personalData.dados_cadastrais_funcionario[0] &&
            personalData.dados_cadastrais_funcionario.map(
              (funcionario, index) => {
                return (
                  <div key={`key-dados_cadastrais_funcionario${index}`}>
                    <section>
                      <div id="dados-cadastrais">
                        {funcionario.Dados_Cadastrais?.Matricula_Empregado && (
                          <h2>
                            Matrícula -
                            {funcionario.Dados_Cadastrais?.Matricula_Empregado}
                          </h2>
                        )}

                        <h3>Dados Cadastrais</h3>

                        {funcionario.Dados_Cadastrais?.Matricula_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Matricula_Empregado
                            }
                            disabled
                            label="Matrícula"
                            value={
                              funcionario.Dados_Cadastrais?.Matricula_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Nome_Empregado && (
                          <TextField
                            title={funcionario.Dados_Cadastrais?.Nome_Empregado}
                            disabled
                            label="Nome completo"
                            value={funcionario.Dados_Cadastrais?.Nome_Empregado}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Genero_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Genero_Empregado
                            }
                            disabled
                            label="Gênero"
                            value={
                              funcionario.Dados_Cadastrais?.Genero_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Nascimento_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Nascimento_Empregado
                            }
                            disabled
                            label="Data de nascimento"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Nascimento_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Endereco_Residencial_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Endereco_Residencial_Empregado
                            }
                            disabled
                            label="Endereço"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Endereco_Residencial_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_Logradouro_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Logradouro_Empregado
                            }
                            disabled
                            label="Número do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Logradouro_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Complemento_Endereco_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Complemento_Endereco_Empregado
                            }
                            disabled
                            label="Complemento do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Complemento_Endereco_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Cidade_Endereco_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Cidade_Endereco_Empregado
                            }
                            disabled
                            label="Cidade do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Cidade_Endereco_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Estado_Endereco_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Estado_Endereco_Empregado
                            }
                            disabled
                            label="Estado do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Estado_Endereco_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.CEP_Endereco_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.CEP_Endereco_Empregado
                            }
                            disabled
                            label="CEP do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.CEP_Endereco_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Tipo_Endereco_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Tipo_Endereco_Empregado
                            }
                            disabled
                            label="Tipo do logradouro"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Tipo_Endereco_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Telefone_Residencial_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Telefone_Residencial_Empregado
                            }
                            disabled
                            label="Telefone residencial"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Telefone_Residencial_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Celular_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Celular_Empregado
                            }
                            disabled
                            label="Telefone celular"
                            value={
                              funcionario.Dados_Cadastrais?.Celular_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Email_Pessoal_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Email_Pessoal_Empregado
                            }
                            disabled
                            label="E-mail"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Email_Pessoal_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.CPF_Empregado && (
                          <TextField
                            title={funcionario.Dados_Cadastrais?.CPF_Empregado}
                            disabled
                            label="CPF"
                            value={funcionario.Dados_Cadastrais?.CPF_Empregado}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.RG_Empregado && (
                          <TextField
                            title={funcionario.Dados_Cadastrais?.RG_Empregado}
                            disabled
                            label="RG"
                            value={funcionario.Dados_Cadastrais?.RG_Empregado}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.UF_Emissor_RG_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.UF_Emissor_RG_Empregado
                            }
                            disabled
                            label="Estado emissor do RG"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.UF_Emissor_RG_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Orgao_Emissor_RG_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_RG_Empregado
                            }
                            disabled
                            label="Órgão emissor RG"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_RG_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Dt_Expedicao_Emissor_RG_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Expedicao_Emissor_RG_Empregado
                            }
                            disabled
                            label="Data de expedição do RG"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Expedicao_Emissor_RG_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Número"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Serie_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Serie_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Série"
                            value={
                              funcionario.Dados_Cadastrais?.Serie_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Letra_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Letra_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Letra"
                            value={
                              funcionario.Dados_Cadastrais?.Letra_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Estado_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Estado_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Estado emissor"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Estado_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Expedicao_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Data de expedição"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Dt_Validade_CTPS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Validade_CTPS_Empregado
                            }
                            disabled
                            label="CTPS Data de validade"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Validade_CTPS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Numero_PIS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Numero_PIS_Empregado
                            }
                            disabled
                            label="Número do PIS"
                            value={
                              funcionario.Dados_Cadastrais?.Numero_PIS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.DT_Expedicao_PIS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.DT_Expedicao_PIS_Empregado
                            }
                            disabled
                            label="Data de expedição do PIS"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.DT_Expedicao_PIS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_Inscricao_INSS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Inscricao_INSS_Empregado
                            }
                            disabled
                            label="Número de inscrição do INSS"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Inscricao_INSS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_Beneficio_INSS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Beneficio_INSS_Empregado
                            }
                            disabled
                            label="Número do benefício do INSS"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Beneficio_INSS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Classe_Contribuicao_INSS_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Classe_Contribuicao_INSS_Empregado
                            }
                            disabled
                            label="Classe de contribuição do INSS"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Classe_Contribuicao_INSS_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Numero_RIC_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Numero_RIC_Empregado
                            }
                            disabled
                            label="Número do RIC"
                            value={
                              funcionario.Dados_Cadastrais?.Numero_RIC_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Orgao_Emissor_RIC_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_RIC_Empregado
                            }
                            disabled
                            label="Órgão emissor do RIC"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_RIC_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Expedicao_RIC_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_RIC_Empregado
                            }
                            disabled
                            label="Data de expedição do RIC"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_RIC_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Carteira_Habilitacao_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Carteira_Habilitacao_Empregado
                            }
                            disabled
                            label="CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Carteira_Habilitacao_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Categoria_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Categoria_CNH_Empregado
                            }
                            disabled
                            label="Categoria da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Categoria_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Orgao_Emissor_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_CNH_Empregado
                            }
                            disabled
                            label="Órgão emissor da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Emissor_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Expedicao_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_CNH_Empregado
                            }
                            disabled
                            label="Data de expedição da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Expedicao_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Validade_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Validade_CNH_Empregado
                            }
                            disabled
                            label="Data de validade da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Validade_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.UF_Expedicao_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.UF_Expedicao_CNH_Empregado
                            }
                            disabled
                            label="Estado da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.UF_Expedicao_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Dt_Primeira_Hab_CNH_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Primeira_Hab_CNH_Empregado
                            }
                            disabled
                            label="Data da primeira habilitação da CNH do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Primeira_Hab_CNH_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Carteira_Habilitacao_2019 && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Carteira_Habilitacao_2019
                            }
                            disabled
                            label="CNH do empregado modelo 2019"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Carteira_Habilitacao_2019
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Orgao_Carteira_Habilitacao_2019 && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Carteira_Habilitacao_2019
                            }
                            disabled
                            label="Órgão emissor da CNH do empregado modelo 2019"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Orgao_Carteira_Habilitacao_2019
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_expedicao_Carteira_Hab_2019 && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_expedicao_Carteira_Hab_2019
                            }
                            disabled
                            label="Data de expedição da CNH do empregado modelo 2019"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_expedicao_Carteira_Hab_2019
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_Titulo_Eleitor_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Titulo_Eleitor_Empregado
                            }
                            disabled
                            label="Número do título de eleitor"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Titulo_Eleitor_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Secao_TE_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Secao_TE_Empregado
                            }
                            disabled
                            label="Seção do título de eleitor"
                            value={
                              funcionario.Dados_Cadastrais?.Secao_TE_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Zona_TE_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Zona_TE_Empregado
                            }
                            disabled
                            label="Zona eleitoral do título de eleitor"
                            value={
                              funcionario.Dados_Cadastrais?.Zona_TE_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Certificado_Reservista_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Certificado_Reservista_Empregado
                            }
                            disabled
                            label="Número do certificado de reservista"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Certificado_Reservista_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Complemento_CR_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Complemento_CR_Empregado
                            }
                            disabled
                            label="Complemento do certificado de reservista"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Complemento_CR_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Codgio_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Codgio_Orgao_Classe_Empregado
                            }
                            disabled
                            label="Código do órgão de classe (OAB, CREA, etc)"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Codgio_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Regiao_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Regiao_Orgao_Classe_Empregado
                            }
                            disabled
                            label="Região do órgão da classe"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Regiao_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Numero_Regiao_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Regiao_Orgao_Classe_Empregado
                            }
                            disabled
                            label="Número da região do órgão"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Numero_Regiao_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.UF_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.UF_Orgao_Classe_Empregado
                            }
                            disabled
                            label="UF da região do órgão"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.UF_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Dt_Expedicao_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Expedicao_Orgao_Classe_Empregado
                            }
                            disabled
                            label="Data de expedição do órgão da classe"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Expedicao_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Dt_Validade_Orgao_Classe_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Validade_Orgao_Classe_Empregado
                            }
                            disabled
                            label="Data de validade do órgão da classe"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Dt_Validade_Orgao_Classe_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Admissao_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Admissao_Empregado
                            }
                            disabled
                            label="Data de admissão do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Admissao_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Data_Termino_Contrato_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Data_Termino_Contrato_Empregado
                            }
                            disabled
                            label="Data de término do contrato do empregado"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Data_Termino_Contrato_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Nome_Mae_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Nome_Mae_Empregado
                            }
                            disabled
                            label="Nome da mãe do empregado"
                            value={
                              funcionario.Dados_Cadastrais?.Nome_Mae_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Nome_Pai_Empregado && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Nome_Pai_Empregado
                            }
                            disabled
                            label="Nome do pai do empregado"
                            value={
                              funcionario.Dados_Cadastrais?.Nome_Pai_Empregado
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Natureza_Estagio && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Natureza_Estagio
                            }
                            disabled
                            label="Natureza do estágio (caso seja estagiário)"
                            value={
                              funcionario.Dados_Cadastrais?.Natureza_Estagio
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.CPF_Coordenador_Estagio && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.CPF_Coordenador_Estagio
                            }
                            disabled
                            label="CPF do coordenador do estágio (caso seja estagiário)"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.CPF_Coordenador_Estagio
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Nome_Coordenador_Estagio && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Nome_Coordenador_Estagio
                            }
                            disabled
                            label="Nome do coordenador do estágio (caso seja estagiário)"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Nome_Coordenador_Estagio
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais
                          ?.Apolice_Seguro_Estagio && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais
                                ?.Apolice_Seguro_Estagio
                            }
                            disabled
                            label="Número de apólice do seguro de estágio (caso seja estagiário)"
                            value={
                              funcionario.Dados_Cadastrais
                                ?.Apolice_Seguro_Estagio
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}

                        {funcionario.Dados_Cadastrais?.Data_Fim_Estagio && (
                          <TextField
                            title={
                              funcionario.Dados_Cadastrais?.Data_Fim_Estagio
                            }
                            disabled
                            label="Data fim do estágio (caso seja estagiário)"
                            value={
                              funcionario.Dados_Cadastrais?.Data_Fim_Estagio
                            }
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      </div>

                      <div id="dados-dependentes">
                        {!!funcionario.Dependentes &&
                          funcionario.Dependentes[0] &&
                          funcionario.Dependentes.map((dependente, index) => {
                            return (
                              <div key={`dependentes-${index + 1}`}>
                                <h3>Dados Dependente - {index + 1}</h3>

                                {dependente?.Nome_Dependente && (
                                  <TextField
                                    title={dependente?.Nome_Dependente}
                                    disabled
                                    label="Nome do dependente"
                                    value={dependente?.Nome_Dependente}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Data_Nascimento_Dependente && (
                                  <TextField
                                    title={
                                      dependente?.Data_Nascimento_Dependente
                                    }
                                    disabled
                                    label="Data de nascimento do dependente"
                                    value={
                                      dependente?.Data_Nascimento_Dependente
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Numero_CPF_Dependente && (
                                  <InputMask
                                    mask="999.999.999-99"
                                    value={dependente?.Numero_CPF_Dependente}
                                    name="CPF do dependente"
                                    disabled
                                    maskChar=""
                                    ref={RInputMask}
                                    children={(inputProps: any) => (
                                      <TextField
                                        {...inputProps}
                                        label="CPF"
                                        disabled
                                        title={
                                          dependente?.Numero_CPF_Dependente
                                        }
                                        variant="outlined"
                                        className="TextField-lgpd-admin"
                                      />
                                    )}
                                  />
                                )}

                                {dependente?.Numero_RG_Dependente && (
                                  <TextField
                                    title={dependente?.Numero_RG_Dependente}
                                    disabled
                                    label="RG do dependente"
                                    value={dependente?.Numero_RG_Dependente}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Estado_Emissor_RG_Dependente && (
                                  <TextField
                                    title={
                                      dependente?.Estado_Emissor_RG_Dependente
                                    }
                                    disabled
                                    label="UF do órgão expedidor do RG do dependente"
                                    value={
                                      dependente?.Estado_Emissor_RG_Dependente
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Orgao_Emissor_RG_Dpendente && (
                                  <TextField
                                    title={
                                      dependente?.Orgao_Emissor_RG_Dpendente
                                    }
                                    disabled
                                    label="Órgão expedidor do RG do dependente"
                                    value={
                                      dependente?.Orgao_Emissor_RG_Dpendente
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Data_Expedicao_RG_Dependente && (
                                  <TextField
                                    title={
                                      dependente?.Data_Expedicao_RG_Dependente
                                    }
                                    disabled
                                    label="Data de expedição do RG"
                                    value={
                                      dependente?.Data_Expedicao_RG_Dependente
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Ds_Parentesco && (
                                  <TextField
                                    title={dependente?.Ds_Parentesco}
                                    disabled
                                    label="Grau de parentesco do dependente"
                                    value={dependente?.Ds_Parentesco}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Cartorio_Registor_Dependente && (
                                  <TextField
                                    title={
                                      dependente?.Cartorio_Registor_Dependente
                                    }
                                    disabled
                                    label="Cartório de registro de nascimento do dependente"
                                    value={
                                      dependente?.Cartorio_Registor_Dependente
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.NRO_REGISTRO && (
                                  <TextField
                                    title={dependente?.NRO_REGISTRO}
                                    disabled
                                    label="Número de registro do nascimento do dependente"
                                    value={dependente?.NRO_REGISTRO}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Numero_Livro_Registro_Dep && (
                                  <TextField
                                    title={
                                      dependente?.Numero_Livro_Registro_Dep
                                    }
                                    disabled
                                    label="Livro de registro de nascimento"
                                    value={
                                      dependente?.Numero_Livro_Registro_Dep
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Numero_Folha_Registro_Dep && (
                                  <TextField
                                    title={
                                      dependente?.Numero_Folha_Registro_Dep
                                    }
                                    disabled
                                    label="Folha de registro do nascimento do dependente"
                                    value={
                                      dependente?.Numero_Folha_Registro_Dep
                                    }
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}

                                {dependente?.Genero_Dependente && (
                                  <TextField
                                    title={dependente?.Genero_Dependente}
                                    disabled
                                    label="Gênero do dependente"
                                    value={dependente?.Genero_Dependente}
                                    variant="outlined"
                                    className="TextField-lgpd-admin"
                                  />
                                )}
                              </div>
                            );
                          })}
                      </div>

                      <div id="dados-beneficiarios">
                        {!!funcionario.Beneficiarios &&
                          funcionario.Beneficiarios[0] &&
                          funcionario.Beneficiarios.map(
                            (beneficiarios, index) => {
                              return (
                                <div key={`dependentes-${index + 1}`}>
                                  <h3>Dados Beneficiario - {index + 1}</h3>

                                  {beneficiarios?.Numero_CPF_Beneficiario && (
                                    <InputMask
                                      mask="999.999.999-99"
                                      value={
                                        beneficiarios?.Numero_CPF_Beneficiario
                                      }
                                      name="CPF do beneficiário"
                                      disabled
                                      maskChar=""
                                      ref={RInputMask}
                                      children={(inputProps: any) => (
                                        <TextField
                                          {...inputProps}
                                          label="CPF"
                                          disabled
                                          title={
                                            beneficiarios?.Numero_CPF_Beneficiario
                                          }
                                          variant="outlined"
                                          className="TextField-lgpd-admin"
                                        />
                                      )}
                                    />
                                  )}

                                  {beneficiarios?.Numero_RG_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Numero_RG_Beneficiario
                                      }
                                      disabled
                                      label="RG do beneficiário"
                                      value={
                                        beneficiarios?.Numero_RG_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Orgao_Emissor_RG_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Orgao_Emissor_RG_Beneficiario
                                      }
                                      disabled
                                      label="Órgão expedidor do RG do beneficiário"
                                      value={
                                        beneficiarios?.Orgao_Emissor_RG_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Estado_Emissor_RG_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Estado_Emissor_RG_Beneficiario
                                      }
                                      disabled
                                      label="UF do expedidor do RG do beneficiário"
                                      value={
                                        beneficiarios?.Estado_Emissor_RG_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Nome_Beneficiario && (
                                    <TextField
                                      title={beneficiarios?.Nome_Beneficiario}
                                      disabled
                                      label="Nome do beneficiário"
                                      value={beneficiarios?.Nome_Beneficiario}
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Endereco_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Endereco_Beneficiario
                                      }
                                      disabled
                                      label="Endereço do beneficiário"
                                      value={
                                        beneficiarios?.Endereco_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Numero_Endereco_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Numero_Endereco_Beneficiario
                                      }
                                      disabled
                                      label="Número do logradouro do beneficiário"
                                      value={
                                        beneficiarios?.Numero_Endereco_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Complemento_End_Beneficiario && (
                                    <TextField
                                      title={
                                        beneficiarios?.Complemento_End_Beneficiario
                                      }
                                      disabled
                                      label="Complemento do logradouro do beneficiário"
                                      value={
                                        beneficiarios?.Complemento_End_Beneficiario
                                      }
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Bairro_Beneficiario && (
                                    <TextField
                                      title={beneficiarios?.Bairro_Beneficiario}
                                      disabled
                                      label="Bairro do beneficiário"
                                      value={beneficiarios?.Bairro_Beneficiario}
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Cidade_Beneficiario && (
                                    <TextField
                                      title={beneficiarios?.Cidade_Beneficiario}
                                      disabled
                                      label="Cidade do logradouro do beneficiário"
                                      value={beneficiarios?.Cidade_Beneficiario}
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.Estado_Beneficiario && (
                                    <TextField
                                      title={beneficiarios?.Estado_Beneficiario}
                                      disabled
                                      label="UF do logradouro do beneficiário"
                                      value={beneficiarios?.Estado_Beneficiario}
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}

                                  {beneficiarios?.CEP_Beneficiario && (
                                    <TextField
                                      title={beneficiarios?.CEP_Beneficiario}
                                      disabled
                                      label="CEP do logradouro do beneficiário"
                                      value={beneficiarios?.CEP_Beneficiario}
                                      variant="outlined"
                                      className="TextField-lgpd-admin"
                                    />
                                  )}
                                </div>
                              );
                            },
                          )}
                      </div>

                      <div id="dados-financeiros">
                        {!!funcionario?.Dados_Financeiros
                          ?.Codigo_Agencia_Bancaria_Empregado &&
                          !!funcionario?.Dados_Financeiros
                            ?.Codigo_Banco_Empregado &&
                          !!funcionario?.Dados_Financeiros
                            ?.Conta_Corrente_Empregado &&
                          !!funcionario?.Dados_Financeiros
                            ?.DV_Conta_Corrente_Empregado && (
                            <>
                              <h3>Dados Financeiros</h3>

                              <TextField
                                title={
                                  funcionario?.Dados_Financeiros
                                    ?.Codigo_Banco_Empregado
                                }
                                disabled
                                label="Nome do banco"
                                value={
                                  funcionario?.Dados_Financeiros
                                    ?.Codigo_Banco_Empregado
                                }
                                variant="outlined"
                                className="TextField-lgpd-admin"
                              />

                              <TextField
                                title={
                                  funcionario?.Dados_Financeiros
                                    ?.Codigo_Agencia_Bancaria_Empregado
                                }
                                disabled
                                label="Agência bancária"
                                value={
                                  funcionario?.Dados_Financeiros
                                    ?.Codigo_Agencia_Bancaria_Empregado
                                }
                                variant="outlined"
                                className="TextField-lgpd-admin"
                              />

                              <TextField
                                title={
                                  funcionario?.Dados_Financeiros
                                    ?.Conta_Corrente_Empregado
                                }
                                disabled
                                label="Conta corrente"
                                value={
                                  funcionario?.Dados_Financeiros
                                    ?.Conta_Corrente_Empregado
                                }
                                variant="outlined"
                                className="TextField-lgpd-admin"
                              />

                              <TextField
                                title={
                                  funcionario?.Dados_Financeiros
                                    ?.DV_Conta_Corrente_Empregado
                                }
                                disabled
                                label="Dígito da conta"
                                value={
                                  funcionario?.Dados_Financeiros
                                    ?.DV_Conta_Corrente_Empregado
                                }
                                variant="outlined"
                                className="TextField-lgpd-admin"
                              />
                            </>
                          )}
                      </div>
                    </section>

                    <div id="add-info">
                      <div style={{ marginTop: -20 }}>
                        {funcionario.tem_beneficiarios &&
                          funcionario.tem_dependentes && (
                            <p style={{ color: '#FFF' }}>
                              A Sky também possui informações sobre seus
                              dependentes e beneficiários
                            </p>
                          )}

                        {!funcionario.tem_beneficiarios &&
                          funcionario.tem_dependentes && (
                            <p style={{ color: '#FFF' }}>
                              A Sky também possui informações sobre seus
                              dependentes
                            </p>
                          )}

                        {funcionario.tem_beneficiarios &&
                          !funcionario.tem_dependentes && (
                            <p style={{ color: '#FFF' }}>
                              A Sky também possui informações sobre seus
                              beneficiários
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                );
              },
            )}
        </>
      ) : (
        ''
      )}

      {personalData?.tipo === 4 ? (
        <>
          {personalData?.instaladores &&
            personalData?.instaladores[0] &&
            personalData?.instaladores?.map((instalador, index) => {
              return (
                <section key={`instaladores-${index + 1}`}>
                  <h2>
                    Contrato - instalador - {instalador.Numero_instalador}
                  </h2>

                  <h3>Dados Cadastrais</h3>

                  {instalador.Nome_Instalador && (
                    <TextField
                      title={instalador.Nome_Instalador}
                      disabled
                      label="Nome do instalador"
                      value={instalador.Nome_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Email_Instalador && (
                    <TextField
                      title={instalador.Email_Instalador}
                      disabled
                      label="Endereço de e-mail do instalador"
                      value={instalador.Email_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.RG_Instalador && (
                    <TextField
                      title={instalador.RG_Instalador}
                      disabled
                      label="RG do instalador"
                      value={instalador.RG_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Celular_com_DDD_Instalador && (
                    <TextField
                      title={instalador.Celular_com_DDD_Instalador}
                      disabled
                      label="Telefone do Whatsapp"
                      value={instalador.Celular_com_DDD_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Telefone_1_com_DDD_Instalador && (
                    <TextField
                      title={instalador.Telefone_1_com_DDD_Instalador}
                      disabled
                      label="Número do telefone 1"
                      value={instalador.Telefone_1_com_DDD_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Telefone_2_com_DDD_Instalador && (
                    <TextField
                      title={instalador.Telefone_2_com_DDD_Instalador}
                      disabled
                      label="Número do telefone 2"
                      value={instalador.Telefone_2_com_DDD_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Telefone_3_com_DDD_Instalador && (
                    <TextField
                      title={instalador.Telefone_3_com_DDD_Instalador}
                      disabled
                      label="Número do telefone 3"
                      value={instalador.Telefone_3_com_DDD_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Telefone_4_com_DDD_Instalador && (
                    <TextField
                      title={instalador.Telefone_4_com_DDD_Instalador}
                      disabled
                      label="Número do telefone 4"
                      value={instalador.Telefone_4_com_DDD_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Endereco_Instalador && (
                    <TextField
                      title={instalador.Endereco_Instalador}
                      disabled
                      label="Endereço"
                      value={instalador.Endereco_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Complemento_Endereco_Instalador && (
                    <TextField
                      title={instalador.Complemento_Endereco_Instalador}
                      disabled
                      label="Complemento do logradouro"
                      value={instalador.Complemento_Endereco_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Cidade_Logradouro_Instalador && (
                    <TextField
                      title={instalador.Cidade_Logradouro_Instalador}
                      disabled
                      label="Nome da cidade"
                      value={instalador.Cidade_Logradouro_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.CEP_Logradouro_Instalador && (
                    <TextField
                      title={instalador.CEP_Logradouro_Instalador}
                      disabled
                      label="CEP do logradouro do instalador"
                      value={instalador.CEP_Logradouro_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Numero_Endereco_Instalador && (
                    <TextField
                      title={instalador.Numero_Endereco_Instalador}
                      disabled
                      label="Número do prédio"
                      value={instalador.Numero_Endereco_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {instalador.Telefone_Contato_referencia_Instalador && (
                    <TextField
                      title={instalador.Telefone_Contato_referencia_Instalador}
                      disabled
                      label="Telefone da referência de contato"
                      value={instalador.Telefone_Contato_referencia_Instalador}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}
                </section>
              );
            })}

          {personalData?.terceiros &&
            personalData.terceiros[0] &&
            personalData.terceiros?.map((terceiro, index) => {
              return (
                <section key={`terceiros-${index + 1}`}>
                  <h2>{terceiro?.conta}</h2>

                  <h3>Dados Cadastrais</h3>

                  {terceiro.CPF_Terceiro && (
                    <InputMask
                      mask="999.999.999-99"
                      value={terceiro.CPF_Terceiro}
                      name="CPF do usuário"
                      disabled
                      maskChar=""
                      ref={RInputMask}
                      children={(inputProps: any) => (
                        <TextField
                          {...inputProps}
                          label="CPF do usuário"
                          disabled
                          title={terceiro.CPF_Terceiro}
                          variant="outlined"
                          className="TextField-lgpd-admin"
                        />
                      )}
                    />
                  )}

                  {terceiro.RG_Terceiro && (
                    <TextField
                      title={terceiro.RG_Terceiro}
                      disabled
                      label="RG do usuário"
                      value={terceiro.RG_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Nome_Terceiro && (
                    <TextField
                      title={terceiro.Nome_Terceiro}
                      disabled
                      label="Nome inteiro do usuário"
                      value={terceiro.Nome_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Email_Terceiro && (
                    <TextField
                      title={terceiro.Email_Terceiro}
                      disabled
                      label="E-mail do usuário"
                      value={terceiro.Email_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Email_Gestor_Terceiro && (
                    <TextField
                      title={terceiro.Email_Gestor_Terceiro}
                      disabled
                      label="E-mail comercial do usuário"
                      value={terceiro.Email_Gestor_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Numero_Fax_Terceiro && (
                    <TextField
                      title={terceiro.Numero_Fax_Terceiro}
                      disabled
                      label="Fax do usuário"
                      value={terceiro.Numero_Fax_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Numero_Telefone_Reidencia_Terceiro && (
                    <TextField
                      title={terceiro.Numero_Telefone_Reidencia_Terceiro}
                      disabled
                      label="Telefone residencial do usuário"
                      value={terceiro.Numero_Telefone_Reidencia_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Numero_Celular_Terceiro && (
                    <TextField
                      title={terceiro.Numero_Celular_Terceiro}
                      disabled
                      label="Celular do usuário"
                      value={terceiro.Numero_Celular_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Numero_Telefone_Terceiro && (
                    <TextField
                      title={terceiro.Numero_Telefone_Terceiro}
                      disabled
                      label="Telefone do usuário"
                      value={terceiro.Numero_Telefone_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Caixa_Postal_Terceiro && (
                    <TextField
                      title={terceiro.Caixa_Postal_Terceiro}
                      disabled
                      label="CEP do usuário"
                      value={terceiro.Caixa_Postal_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Endereco_Terceiro && (
                    <TextField
                      title={terceiro.Endereco_Terceiro}
                      disabled
                      label="Endereço do usuário"
                      value={terceiro.Endereco_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.UF_Terceiro && (
                    <TextField
                      title={terceiro.UF_Terceiro}
                      disabled
                      label="Estado do logradouro do usuário"
                      value={terceiro.UF_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Login_EPS_Terceiro && (
                    <TextField
                      title={terceiro.Login_EPS_Terceiro}
                      disabled
                      label="Login EPS usuário"
                      value={terceiro.Login_EPS_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.EPS_Callcenter_Terceiro && (
                    <TextField
                      title={terceiro.EPS_Callcenter_Terceiro}
                      disabled
                      label="EPS Callcenter usuário"
                      value={terceiro.EPS_Callcenter_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.EPS_Celula_Callcenter_Terceiro && (
                    <TextField
                      title={terceiro.EPS_Celula_Callcenter_Terceiro}
                      disabled
                      label="EPS Célula do Callcenter usuário"
                      value={terceiro.EPS_Celula_Callcenter_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Login_Avaya_Terceiro && (
                    <TextField
                      title={terceiro.Login_Avaya_Terceiro}
                      disabled
                      label="Login Avaya usuário"
                      value={terceiro.Login_Avaya_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Matricula_EPS_Terceiro && (
                    <TextField
                      title={terceiro.Matricula_EPS_Terceiro}
                      disabled
                      label="Matrícula EPS usuário"
                      value={terceiro.Matricula_EPS_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Numero_logradouro_Terceiro && (
                    <TextField
                      title={terceiro.Numero_logradouro_Terceiro}
                      disabled
                      label="Número do logradouro usuário"
                      value={terceiro.Numero_logradouro_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Complemento_Endereco_Terceiro && (
                    <TextField
                      title={terceiro.Complemento_Endereco_Terceiro}
                      disabled
                      label="Complemento do logradouro usuário"
                      value={terceiro.Complemento_Endereco_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Cidade_logradouro_Terceiro && (
                    <TextField
                      title={terceiro.Cidade_logradouro_Terceiro}
                      disabled
                      label="Cidade do logradouro usuário"
                      value={terceiro.Cidade_logradouro_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Distrito_Logradouro_Terceiro && (
                    <TextField
                      title={terceiro.Distrito_Logradouro_Terceiro}
                      disabled
                      label="Bairro do logradouro usuário"
                      value={terceiro.Distrito_Logradouro_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {terceiro.Data_Nascimento_Terceiro && (
                    <TextField
                      title={terceiro.Data_Nascimento_Terceiro}
                      disabled
                      label="Data de nascimento usuário"
                      value={terceiro.Data_Nascimento_Terceiro}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}
                </section>
              );
            })}

          {personalData?.pontos_de_venda &&
            personalData.pontos_de_venda[0] &&
            personalData.pontos_de_venda.map((pontos, index) => {
              return (
                <section key={`pontos_de_venda-${index + 1}`}>
                  <h2>{pontos.conta}</h2>

                  <h3>Dados Cadastrais</h3>

                  {pontos.CPF_Parceiro_Vendedor && (
                    <InputMask
                      mask="999.999.999-99"
                      value={pontos.CPF_Parceiro_Vendedor}
                      name="CPF do vendedor"
                      disabled
                      maskChar=""
                      ref={RInputMask}
                      children={(inputProps: any) => (
                        <TextField
                          {...inputProps}
                          label="CPF do vendedor"
                          disabled
                          title={pontos.CPF_Parceiro_Vendedor}
                          variant="outlined"
                          className="TextField-lgpd-admin"
                        />
                      )}
                    />
                  )}

                  {pontos.RG_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.RG_Parceiro_Vendedor}
                      disabled
                      label="RG do vendodor"
                      value={pontos.RG_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Nome_Empresa_Vendedor && (
                    <TextField
                      title={pontos.Nome_Empresa_Vendedor}
                      disabled
                      label="Nome de contato"
                      value={pontos.Nome_Empresa_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Nome_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Nome_Parceiro_Vendedor}
                      disabled
                      label="Primeiro nome do vendedor"
                      value={pontos.Nome_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Sobrenome_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Sobrenome_Parceiro_Vendedor}
                      disabled
                      label="Sobrenome do vendedor"
                      value={pontos.Sobrenome_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Email_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Email_Parceiro_Vendedor}
                      disabled
                      label="Endereço de e-mail do vendedor"
                      value={pontos.Email_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Telefone_Res_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Telefone_Res_Parceiro_Vendedor}
                      disabled
                      label="Telefone residencial do vendedor"
                      value={pontos.Telefone_Res_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Celular_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Celular_Parceiro_Vendedor}
                      disabled
                      label="Telefone celular do vendedor"
                      value={pontos.Celular_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Outro_Telefone_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Outro_Telefone_Parceiro_Vendedor}
                      disabled
                      label="Outro telefone do vendedor"
                      value={pontos.Outro_Telefone_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Foto_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Foto_Parceiro_Vendedor}
                      disabled
                      label="Cadastro da URL da foto do vendedor"
                      value={pontos.Foto_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Genero_Vendedor && (
                    <TextField
                      title={pontos.Genero_Vendedor}
                      disabled
                      label="Gênero do vendedor"
                      value={pontos.Genero_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}

                  {pontos.Telefone_Parceiro_Vendedor && (
                    <TextField
                      title={pontos.Telefone_Parceiro_Vendedor}
                      disabled
                      label="Telefone parceiro vendedor"
                      value={pontos.Telefone_Parceiro_Vendedor}
                      variant="outlined"
                      className="TextField-lgpd-admin"
                    />
                  )}
                </section>
              );
            })}

          {renderInfoTypeFour()}
        </>
      ) : (
        ''
      )}

      {personalData?.tipo === 5 ? (
        <>
          {personalData?.dados_cadastrais_candidato &&
            personalData.dados_cadastrais_candidato[0] &&
            personalData.dados_cadastrais_candidato.map((candidato, index) => {
              return (
                <div key={`candidato-${index + 1}`}>
                  <section>
                    <h2>Candidato - {candidato.CPF_Candidato}</h2>

                    <h3>candidato Cadastrais</h3>

                    {candidato?.CPF_Candidato && (
                      <InputMask
                        mask="999.999.999-99"
                        value={candidato?.CPF_Candidato}
                        name="CPF"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CPF do candidato"
                            disabled
                            title={candidato?.CPF_Candidato}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {candidato?.Nome_Candidato && (
                      <TextField
                        title={candidato?.Nome_Candidato}
                        disabled
                        label="Primeiro nome"
                        value={candidato?.Nome_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Sobrenome_Candidato && (
                      <TextField
                        title={candidato?.Sobrenome_Candidato}
                        disabled
                        label="Sobrenome"
                        value={candidato?.Sobrenome_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Data_Nascimento_Candidato && (
                      <TextField
                        title={candidato?.Data_Nascimento_Candidato}
                        disabled
                        label="Data de nascimento"
                        value={candidato?.Data_Nascimento_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Numero_RG_Candidato && (
                      <TextField
                        title={candidato?.Numero_RG_Candidato}
                        disabled
                        label="RG"
                        value={candidato?.Numero_RG_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Codigo_Postal_Candidato && (
                      <InputMask
                        mask="99999-999"
                        value={candidato?.Codigo_Postal_Candidato}
                        name="Código Postal ou CEP"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CEP"
                            title={candidato?.Codigo_Postal_Candidato}
                            disabled
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {candidato?.Endereco_residencial_Candidato && (
                      <TextField
                        title={candidato?.Endereco_residencial_Candidato}
                        disabled
                        label="Endereço residencial"
                        value={candidato?.Endereco_residencial_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Endereco_Linha_2_residencial_Candidato && (
                      <TextField
                        title={
                          candidato?.Endereco_Linha_2_residencial_Candidato
                        }
                        disabled
                        label="Linha 2 do endereço"
                        value={
                          candidato?.Endereco_Linha_2_residencial_Candidato
                        }
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Complemento_Endereco_cancidato && (
                      <TextField
                        title={candidato?.Complemento_Endereco_cancidato}
                        disabled
                        label="Complemento do endereço"
                        value={candidato?.Complemento_Endereco_cancidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Cidade_Candidato && (
                      <TextField
                        title={candidato?.Cidade_Candidato}
                        disabled
                        label="Cidade"
                        value={candidato?.Cidade_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Regiao_Logradouro_Candidato && (
                      <TextField
                        title={candidato?.Regiao_Logradouro_Candidato}
                        disabled
                        label="Região"
                        value={candidato?.Regiao_Logradouro_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Estado_Candidato && (
                      <TextField
                        title={candidato?.Estado_Candidato}
                        disabled
                        label="Estado"
                        value={candidato?.Estado_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Pais_Logradouro_Candidato && (
                      <TextField
                        title={candidato?.Pais_Logradouro_Candidato}
                        disabled
                        label="País"
                        value={candidato?.Pais_Logradouro_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Email_Candidato && (
                      <TextField
                        title={candidato?.Email_Candidato}
                        disabled
                        label="E-mail pessoal"
                        value={candidato?.Email_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Tipo_Telefone_Contato_Principal && (
                      <TextField
                        title={candidato?.Tipo_Telefone_Contato_Principal}
                        disabled
                        label="Tipo de telefone do contato principal"
                        value={candidato?.Tipo_Telefone_Contato_Principal}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Celular_Candidato && (
                      <TextField
                        title={candidato?.Celular_Candidato}
                        disabled
                        label="Telefone celular pessoal"
                        value={candidato?.Celular_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Telefone_Comercial_Candidato && (
                      <TextField
                        title={candidato?.Telefone_Comercial_Candidato}
                        disabled
                        label="Telefone comercial"
                        value={candidato?.Telefone_Comercial_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Numero_PIS_Candidato && (
                      <TextField
                        title={candidato?.Numero_PIS_Candidato}
                        disabled
                        label="PIS"
                        value={candidato?.Numero_PIS_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Data_Emissao_PIS_Candidato && (
                      <TextField
                        title={candidato?.Data_Emissao_PIS_Candidato}
                        disabled
                        label="Data de emissão do PIS"
                        value={candidato?.Data_Emissao_PIS_Candidato}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Numero_NIT && (
                      <TextField
                        title={candidato?.Numero_NIT}
                        disabled
                        label="Número NIT"
                        value={candidato?.Numero_NIT}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {candidato?.Data_Cadastro_NIT && (
                      <TextField
                        title={candidato?.Data_Cadastro_NIT}
                        disabled
                        label="Data de emissão do NIT"
                        value={candidato?.Data_Cadastro_NIT}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}
                  </section>
                </div>
              );
            })}

          {personalData?.propostas &&
            personalData.propostas[0] &&
            personalData.propostas.map((proposta, index) => {
              return (
                <div key={`proposta-${index + 1}`}>
                  <section>
                    <h2>Proposta - {proposta.Numero_Proposta_Prosponente}</h2>

                    <h3>Dados Cadastrais</h3>

                    {proposta.Nome_Proponente && (
                      <TextField
                        title={proposta.Nome_Proponente}
                        disabled
                        label="Primeiro nome"
                        value={proposta.Nome_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Nome_Meio_Poroponente && (
                      <TextField
                        title={proposta.Nome_Meio_Poroponente}
                        disabled
                        label="Nome do meio"
                        value={proposta.Nome_Meio_Poroponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Sobrenome_Proponente && (
                      <TextField
                        title={proposta.Sobrenome_Proponente}
                        disabled
                        label="Último nome"
                        value={proposta.Sobrenome_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Endereço_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Endereço_Instalacao_Proponente}
                        disabled
                        label="Endereço de instalação"
                        value={proposta.Endereço_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Numero_End_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Numero_End_Instalacao_Proponente}
                        disabled
                        label="Número de instalação"
                        value={proposta.Numero_End_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Complemento_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Complemento_Instalacao_Proponente}
                        disabled
                        label="Complemento da instalação"
                        value={proposta.Complemento_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Bairro_Proponente && (
                      <TextField
                        title={proposta.Bairro_Proponente}
                        disabled
                        label="Bairro da instalação"
                        value={proposta.Bairro_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.CEP_Instalacao_Proponente && (
                      <InputMask
                        mask="99999-999"
                        value={proposta.CEP_Instalacao_Proponente}
                        name="CEP"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CEP"
                            title={proposta.CEP_Instalacao_Proponente}
                            disabled
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {proposta.Cidade_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Cidade_Instalacao_Proponente}
                        disabled
                        label="Cidade da instalação"
                        value={proposta.Cidade_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Estado_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Estado_Instalacao_Proponente}
                        disabled
                        label="Estado da instalação"
                        value={proposta.Estado_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Tipo_Residencia_Instalacao_Proponente && (
                      <TextField
                        title={proposta.Tipo_Residencia_Instalacao_Proponente}
                        disabled
                        label="Tipo do móvel de instalação"
                        value={proposta.Tipo_Residencia_Instalacao_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Residencial_Proposta_Prosponente && (
                      <TextField
                        title={
                          proposta.Telefone_Residencial_Proposta_Prosponente
                        }
                        disabled
                        label="Telefone residencial"
                        value={
                          proposta.Telefone_Residencial_Proposta_Prosponente
                        }
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Email_Pessoal_Proponente && (
                      <TextField
                        title={proposta.Email_Pessoal_Proponente}
                        disabled
                        label="E-mail pessoal"
                        value={proposta.Email_Pessoal_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Email_Comercial_Proponente && (
                      <TextField
                        title={proposta.Email_Comercial_Proponente}
                        disabled
                        label="E-mail comercial"
                        value={proposta.Email_Comercial_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Celular_Proponente && (
                      <TextField
                        title={proposta.Celular_Proponente}
                        disabled
                        label="Telefone celular"
                        value={proposta.Celular_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Celular_pessoal_Proponente && (
                      <TextField
                        title={proposta.Celular_pessoal_Proponente}
                        disabled
                        label="Telefone celular pessoal"
                        value={proposta.Celular_pessoal_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Proponente && (
                      <TextField
                        title={proposta.Telefone_Proponente}
                        disabled
                        label="Telefone"
                        value={proposta.Telefone_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Comercial_Proponente && (
                      <TextField
                        title={proposta.Telefone_Comercial_Proponente}
                        disabled
                        label="Telefone comercial"
                        value={proposta.Telefone_Comercial_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.CPF_Proponente && (
                      <InputMask
                        mask="999.999.999-99"
                        value={proposta.CPF_Proponente}
                        name="CPF"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CPF"
                            disabled
                            title={proposta.CPF_Proponente}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {proposta.RG_Proponente && (
                      <TextField
                        title={proposta.RG_Proponente}
                        disabled
                        label="RG"
                        value={proposta.RG_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}
                  </section>
                </div>
              );
            })}

          {personalData?.proposta &&
            personalData.proposta[0] &&
            personalData.proposta.map((proposta, index) => {
              return (
                <div key={`proposta-${index + 1}`}>
                  <section>
                    <h2>Proposta - {proposta.Numero_Proposta}</h2>

                    <h3>Dados Cadastrais</h3>

                    {proposta.Nome_Prosponente && (
                      <TextField
                        title={proposta.Nome_Prosponente}
                        disabled
                        label="Primeiro nome"
                        value={proposta.Nome_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Sobrenome_Prosponente && (
                      <TextField
                        title={proposta.Sobrenome_Prosponente}
                        disabled
                        label="Último nome"
                        value={proposta.Sobrenome_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.endereco && (
                      <TextField
                        title={proposta.endereco}
                        disabled
                        label="Endereço de instalação"
                        value={proposta.endereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.numero_endereco && (
                      <TextField
                        title={proposta.numero_endereco}
                        disabled
                        label="Número de instalação"
                        value={proposta.numero_endereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.apartamento && (
                      <TextField
                        title={proposta.apartamento}
                        disabled
                        label="Apartamento da instalação"
                        value={proposta.apartamento}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.complemento_endereco && (
                      <TextField
                        title={proposta.complemento_endereco}
                        disabled
                        label="Complemento da instalação"
                        value={proposta.complemento_endereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.bairro_endereco && (
                      <TextField
                        title={proposta.bairro_endereco}
                        disabled
                        label="Bairro da instalação"
                        value={proposta.bairro_endereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.cependereco && (
                      <InputMask
                        mask="99999-999"
                        value={proposta.cependereco}
                        name="CEP"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CEP"
                            title={proposta.cependereco}
                            disabled
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {proposta.cidade_endereco && (
                      <TextField
                        title={proposta.cidade_endereco}
                        disabled
                        label="Cidade da instalação"
                        value={proposta.cidade_endereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.ufendereco && (
                      <TextField
                        title={proposta.ufendereco}
                        disabled
                        label="Estado da instalação"
                        value={proposta.ufendereco}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Residencial_Prosponente && (
                      <TextField
                        title={proposta.Telefone_Residencial_Prosponente}
                        disabled
                        label="Telefone residencial"
                        value={proposta.Telefone_Residencial_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Email_Prosponente && (
                      <TextField
                        title={proposta.Email_Prosponente}
                        disabled
                        label="E-mail"
                        value={proposta.Email_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Celular_Proponente && (
                      <TextField
                        title={proposta.Telefone_Celular_Proponente}
                        disabled
                        label="Telefone celular"
                        value={proposta.Telefone_Celular_Proponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Telefone_Comercial_Prosponente && (
                      <TextField
                        title={proposta.Telefone_Comercial_Prosponente}
                        disabled
                        label="Telefone comercial"
                        value={proposta.Telefone_Comercial_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.CPF_Prosponente && (
                      <InputMask
                        mask="999.999.999-99"
                        value={proposta.CPF_Prosponente}
                        name="CPF"
                        disabled
                        maskChar=""
                        ref={RInputMask}
                        children={(inputProps: any) => (
                          <TextField
                            {...inputProps}
                            label="CPF"
                            disabled
                            title={proposta.CPF_Prosponente}
                            variant="outlined"
                            className="TextField-lgpd-admin"
                          />
                        )}
                      />
                    )}

                    {proposta.RG_Prosponente && (
                      <TextField
                        title={proposta.RG_Prosponente}
                        disabled
                        label="RG"
                        value={proposta.RG_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}

                    {proposta.Passaporte_Prosponente && (
                      <TextField
                        title={proposta.Passaporte_Prosponente}
                        disabled
                        label="Passaporte"
                        value={proposta.Passaporte_Prosponente}
                        variant="outlined"
                        className="TextField-lgpd-admin"
                      />
                    )}
                  </section>
                </div>
              );
            })}
        </>
      ) : (
        ''
      )}

      <div id="add-info-2">{!!personalData?.tipo && renderInfo()}</div>
    </div>
  );
};

export default Categorias;
